import axios from 'axios';

import WAVELIGHT_URL from './url';

import { getAuthToken } from '../../utils';

export const doPinLoginRequest = async (username: string, pin: string) => {
  const response = await axios.post(
    `${WAVELIGHT_URL}/pin-login/`,
    {
      username,
      pin,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response.data;
};

export const doGetUserProfile = async () => {
  const token = getAuthToken();
  const response = await axios.get(`${WAVELIGHT_URL}/profile/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
